import React from 'react';
import routes from './config';
import { urlAnalyse } from './urlAnalyse';
import styles from './style.module.scss';

var Breadcrumbs = function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
      hidden = _ref.hidden;

  //Module Counter
  var counter = function () {
    var _count = 0;
    return {
      add: function add() {
        _count++;
      },
      get: function get() {
        return _count;
      }
    };
  }();

  function Trenner() {
    var linksNumber = breadcrumbs.length;
    counter.add();

    if (linksNumber !== counter.get()) {
      return React.createElement("span", null, " \u203A ");
    } else {
      return React.createElement("span", null);
    }
  }

  return !hidden ? React.createElement("div", {
    className: styles.breadcrumbs
  }, React.createElement("ul", {
    className: "breadcrumb"
  }, breadcrumbs.map(function (_ref2) {
    var breadcrumb = _ref2.breadcrumb,
        title = _ref2.title,
        path = _ref2.path,
        match = _ref2.match,
        index = _ref2.index;
    return React.createElement("li", {
      itemScope: "itemscope",
      itemType: "http://data-vocabulary.org/Breadcrumb",
      key: path
    }, React.createElement("a", {
      itemProp: "url",
      href: match.url + '/',
      title: title
    }, React.createElement("span", {
      itemProp: "title"
    }, breadcrumb)), React.createElement(Trenner, null));
  }))) : null;
};

export default urlAnalyse(routes)(Breadcrumbs);